import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { OrganizationEndpoint } from '../constants/organization-endpoint';
import { OrganizationBrief, OrganizationListSearchCriteria } from '../models';
import { getQueryStringFromObject } from '../../../../../common';

@Injectable({
  providedIn: 'root',
})
export class OrganizationListService {
  constructor(private http: WrapperHttpService) {}

  getOrganizationList(searchCriteria: OrganizationListSearchCriteria): Observable<OrganizationBrief[]> {
    const url = `${API_URL}${OrganizationEndpoint.Base}${
      searchCriteria ? `?${getQueryStringFromObject(searchCriteria)}` : ''
    }`;
    return this.http.withLoading().get<OrganizationBrief[]>(url);
  }
}
